import React, { Suspense, useContext } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { CContainer, CFade } from "@coreui/react";
import { useDispatch, useSelector } from "react-redux";
import CompanyList from "./CompanyList";
import { startLogout } from "../redux/actions/auth";

// routes config
import routes from "../routes";
import NoAccess from "./NoAccess";
import { CompanyContext, UserContext } from "src/context";
import { FULL_ACCESS_PLANS, PLANS_SMARTCFO, Plans } from "src/utils/plans";
import Banner from "./banner";
import { Roles } from "src/utils/roles";

function useCheckSession(sessionExp) {
  const logOut = localStorage.getItem("logOut");
  let location = useLocation();
  const dispatch = useDispatch();
  React.useEffect(() => {
    const now = new Date().getTime() / 1000;
    if (now > sessionExp || logOut == "true") {
      localStorage.setItem("logOut", false);
      dispatch(startLogout());
    }
  }, [location, logOut]);
}
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const Content = (props) => {
  const {
    companyName,
    showCompanyList,
    setShowCompanyList,
    hideCompanyList,
    setupdateSideBar,
  } = props

  const user = useContext(UserContext)
  const { sessionExp, roles } = useSelector((state) => state.auth)
  const { selectedCompany } = useSelector((state) => state.companyList)
  const companyPlans = selectedCompany?.plan || []

  const usarLocation=useLocation()

  const conexionesData = useSelector(state => state.conexiones);
  const hasCobranzaOnlineConnection = conexionesData?.allConnections?.some(con => con.templateId === 'cobranzaOnline');

  useCheckSession(sessionExp)
  const country = process.env.REACT_APP_COUNTRY
  const Routes = routes.map(f => {

    if (f.path === '/f-29' && user?.roles?.includes(Roles.USER_SMARTCFO) == false) {
      return {...f }
    }

    if (!FULL_ACCESS_PLANS.some(p => companyPlans.includes(p))) { //PLANES EN LA LISTA TIENEN ACCESO FULL
      if (companyPlans.includes(Plans.flujo_de_caja) == false) {
        if (['/flujo_caja'].includes(f.path)) return { ...f, ...{ component: NoAccess } }
      }

      if (companyPlans.includes(Plans.estado_de_resultados) == false) {
        if (['/eerr'].includes(f.path)) return { ...f, ...{ component: NoAccess } }
      }

      if (companyPlans.includes(Plans.pago_a_proveedores) == false) {
        if (['/pago_proveedores'].includes(f.path)) return { ...f, ...{ component: NoAccess } }
      }
    }

    if (PLANS_SMARTCFO.some(p => companyPlans.includes(p))) {
      if (['/cobranza'].includes(f.path)) return { ...f, ...{ component: NoAccess } }
    }

    if (roles.includes('FLUJO_DE_CAJA')) {
      if (['/reportes', '/reportes_dj', '/pago_proveedores', '/eerr'].includes(f.path)) return { ...f, ...{ component: NoAccess } }
    }

    if (roles?.includes('NOMINAS')) {
      if (['/reportes', '/reportes_dj', '/flujo_caja', '/creditos', '/conexiones', '/eerr', '/dashboard'].includes(f.path)) return { ...f, ...{ component: NoAccess } }
    }

    if (roles?.includes('OPERARIO')) {
      if (['/reportes', '/reportes_dj', '/configuracion', '/eerr', '/conexiones'].includes(f.path)) return { ...f, ...{ component: NoAccess } }
    }
    if (roles?.includes('USER_WITH_COBRANZA')) {
      if (['/reportes', '/reportes_dj', '/eerr', '/conexiones','/flujo_caja','/dashboard','/f-29','/creditos'].includes(f.path)) return { ...f, ...{ component: NoAccess } }
    }
    if (roles?.includes('USER_WITH_OUT_COBRANZA')) {
      if (['/reportes', '/reportes_dj', '/eerr', '/conexiones','/flujo_caja','/dashboard','/f-29','/creditos','/cobranza'].includes(f.path)) return { ...f, ...{ component: NoAccess } }
    }

    if (country === 'COL'){
      if (['/cobranza'].includes(f.path)) return { ...f, ...{ component: NoAccess } }
    }

    if ([].includes(selectedCompany?.id)) { //SOLO PARA CLASSPASS
      if (['/cuadratura'].includes(f.path)) return { ...f, ...{ component: NoAccess } }
    }

    return f
  })

  return (
    <main className={`${props.maximized ? "c-main-open" : "c-main"} mt-5`}>
      <CContainer fluid className="mt-3">
      {usarLocation.pathname === "/cobranza" && !hasCobranzaOnlineConnection && (
        <Banner 
          message="Crea tu cuenta de Cobranza Online de manera GRATUITA en el siguiente" 
          link={"https://app.cobranzaonline.com/"}
        />
      )}
        <Suspense fallback={loading}>
          <Switch>
            {Routes.map((route, idx) => {
              return (
                route.component && (
                  <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    render={(props) => (
                      <CFade>
                        <CompanyList
                          showCompanyList={showCompanyList}
                          setShowCompanyList={setShowCompanyList}
                          companyName={companyName}
                          hideCompanyList={hideCompanyList}
                          setupdateSideBar={setupdateSideBar}
                        />
                        <h5 className="mb-3 w-100 card-title marginLeft">{route?.pageTitle}</h5>
                        <route.component {...props} />
                      </CFade>
                    )}
                  />
                )
              );
            })}
            <Redirect from="/" to="/dashboard" />
          </Switch>
        </Suspense>
      </CContainer>
    </main>
  );
};

export default React.memo(Content);
